export default "__VITE_ASSET__BUY2Eebh__"